import {
  Internship,
  AskLubavButtonEndpoint,
  handleAskLubavApiCall,
  HandleAPICallResponseReturn,
} from '@backrs_ui/common-ui';

import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

const LUBAV_API_URL = process.env.REACT_APP_LUBAV_API_BASEURL;

type HandleApiCallProps = Readonly<{
  url_key: AskLubavButtonEndpoint;
  internship: Internship | null;
  userId: number | undefined;
  askLubavResponseAccumulator?: (chunk: string) => void;
  setAskLubavButtonResponse?: (response: string) => void;
}>;

type AskLubavRequestData = Readonly<{
  id: number;
  internship_name: Internship['role_title'];
  company_name: Internship['company'];
  ai_description: Internship['ai_description'];
  user_id?: number;
}>;

export const handleInternshipApiCall = async ({
  url_key,
  internship,
  userId,
  askLubavResponseAccumulator,
  setAskLubavButtonResponse,
}: HandleApiCallProps): Promise<HandleAPICallResponseReturn | undefined> => {
  if (!internship || !LUBAV_API_URL) {
    return;
  }

  setAskLubavButtonResponse?.('');

  const inputData: AskLubavRequestData = {
    id: internship.id,
    internship_name: internship.role_title,
    company_name: internship.company,
    ai_description: internship.ai_description,
    // anything else we need to add
    ...(userId ? { user_id: userId } : {}),
  };

  return handleAskLubavApiCall<AskLubavRequestData>({
    url_key,
    apiUrl: LUBAV_API_URL,
    inputData,
    userId,
    getToken: getBackrsToken,
    askLubavResponseAccumulator,
  });
};
